export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const PROVIDER_ID = 'providerId';
export const USER_TYPE = 'userType';
export const MULTI_USER = 'multiUser';

export const userDetails = localStorage.getItem(ACCESS_TOKEN);

export const getProviderId = () => {
  try {
    const providerId = localStorage.getItem(PROVIDER_ID);

    if (providerId) {
      return providerId;
    }
    return null;
  } catch (error) {
    throw new Error(error);
  }
};
export const getUserType = () => {
  try {
    const userType = localStorage.getItem(USER_TYPE);

    if (userType) {
      return userType;
    }
    return null;
  } catch (error) {
    throw new Error(error);
  }
};
export const getMultiUser = () => {
  try {
    const userType = localStorage.getItem(MULTI_USER);

    if (userType) {
      return userType === 'true';
    }
    return null;
  } catch (error) {
    throw new Error(error);
  }
};
